/**
 * One-way bridge from the API client to the store.
 *
 * `api.ts` must be able to force a logout (expired token, 401/403) without
 * importing the store — the store's saga graph imports `api.ts`, so the direct
 * import would be a cycle that bites at module-eval time. The store registers
 * its handler here once, at startup.
 */
type AuthFailureHandler = (reason: AuthFailureReason) => void;

export type AuthFailureReason = "token-expired" | "unauthorized" | "forbidden";

let handler: AuthFailureHandler | null = null;

export const setAuthFailureHandler = (next: AuthFailureHandler): void => {
  handler = next;
};

export const notifyAuthFailure = (reason: AuthFailureReason): void => {
  handler?.(reason);
};
